import React, { useEffect, useRef, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@emotion/react';
import { Divider, Grid, Stack } from '@mui/material';
import TextInput from '../Input/TextInput';
import { useTranslation } from 'react-i18next';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import ButtonAction from '../Button.js/SaveButton';
import imgDefault from './upload.png';
import axios from 'axios';
import InputGroupBtn from '../Input/inputGroupBtn';
import Loader from '../loader/loader';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const StyledProductImg = styled('img')({
    // top: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    // position: 'absolute',
});
const SupplierModal = ({ visible = false, dataUpdate, setVisible, fuctGet, idPermission, isEdit }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const [name, setName] = useState('');
    const [nameRepresent, setNameRepresent] = useState('');
    const [email, setemail] = useState('');
    const [address, setaddress] = useState('');
    const [arrSupplier, setArrSupplier] = useState([]);
    const [phone, setphone] = useState('');
    const [code, setcode] = useState('');
    const [flagAddStat, setFlagAddStat] = useState(false);
    const addCabinetFlag = useRef(false);
    const [blob, setBlob] = useState('');
    const [imgEdit, setImgEdit] = useState('');

    const imageName = useRef('');
    const dataReqImg = useRef({
        imgType: '',
        image_data: '',
        size: 0,
        encodeType: null,
    });

    useEffect(() => {
        imageName.current = dataUpdate.logo_supplier;
        if (isEdit) {
            setBlob('');
            setName(dataUpdate.supplier_nm);
            setcode(dataUpdate.supplier_cd);
            setNameRepresent(dataUpdate.auth_rep);
            setphone(dataUpdate.supplier_phone);
            setArrSupplier(dataUpdate?.producer);
            setemail(dataUpdate.email);
            setaddress(dataUpdate.address);
            setImgEdit(dataUpdate.logo_supplier);
            imageName.current = dataUpdate.logo_supplier;
        } else {
            setName('');
            setcode('');
            setphone('');
            setNameRepresent('');
            setArrSupplier([]);
            setemail('');
            setaddress('');
            setBlob('');
            setImgEdit('');
            imageName.current = '';
        }
        setFileToUpload(null);
        setBlob('');
    }, [dataUpdate]);

    const [fileToUpload, setFileToUpload] = useState(null);

    const handleOnChangeFile = async (e) => {
        let file = e.target.files[0];
        if (!file) return;
        if (file.size > 50 * 1024 * 1024) {
            toast.error(t('error.file_too_large'));
            return;
        }
        setFileToUpload(file);
        try {
            const url = URL.createObjectURL(file);
            setBlob(url);
        } catch (err) {
            console.error('Error creating object URL:', err);
        }
    };
    const handleAddReport = async () => {
        if (addCabinetFlag.current) return;
        if (!name || !code || !phone) return toast.error(t('error.param'));

        addCabinetFlag.current = true;
        setFlagAddStat(true);

        try {
            if (fileToUpload) {
                const reader = new FileReader();
                const imageData = await new Promise((resolve, reject) => {
                    reader.onload = (evt) =>
                        resolve(evt.target.result.toString().replace(/^data:image\/\w+;base64,/, ''));
                    reader.onerror = (err) => reject(err);
                    reader.readAsDataURL(fileToUpload);
                });

                const req = await axios.post(`${glb_sv.urlPostProductImage}`, {
                    imgType: fileToUpload.type.slice(6),
                    image_data: imageData,
                    size: fileToUpload.size,
                    encodeType: 'base64',
                });
                if (req?.data?.success) {
                    imageName.current = req.data.data.imageName;
                } else {
                    toast.error(t('error.upload'));
                    setFlagAddStat(false);
                    addCabinetFlag.current = false;
                    return;
                }

                if (!imageName.current || imageName.current === '') {
                    toast.error(t('error.upload'));
                    setFlagAddStat(false);
                    addCabinetFlag.current = false;
                    return;
                }
            }

            if (isEdit) {
                const InVal = [
                    +idPermission,
                    code,
                    name,
                    phone,
                    imageName.current,
                    address,
                    dataUpdate.id,
                    '1',
                    email,
                    nameRepresent,
                    '',
                    JSON.stringify(arrSupplier),
                ];
                sendRequest(serviceList.updatesupplier, InVal, actionResult, true, timeOutFunct, 40000);
            } else {
                const InVal = [
                    +idPermission,
                    code,
                    name,
                    phone,
                    imageName.current,
                    address,
                    '1',
                    email,
                    nameRepresent,
                    '',
                    JSON.stringify(arrSupplier),
                ];
                sendRequest(serviceList.createsupplier, InVal, actionResult, true, timeOutFunct, 40000);
            }
        } catch (error) {
            console.error('Upload error:', error);
            toast.error(t('error.system_error'));
            setFlagAddStat(false);
            addCabinetFlag.current = false;
        }
    };
    const actionResult = (reqInfoMap, message) => {
        addCabinetFlag.current = false;
        setFlagAddStat(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            fuctGet && fuctGet();
            setName('');
            setcode('');
            setphone('');
            setNameRepresent('');
            setArrSupplier([]);
            setemail('');
            setaddress('');
            setBlob('');
            setImgEdit('');
            imageName.current = '';
            dataReqImg.current = null;

            setVisible(!visible);
        }
    };
    const timeOutFunct = (reqInfo) => {
        addCabinetFlag.current = false;
        setFlagAddStat(false);
        toast.error(t('error.time_out'));
    };

    return (
        <BootstrapDialog
            // style={{ minWidth: '650px', width: '100%' }}
            fullScreen={fullScreen}
            open={visible}
            onClose={() => setVisible(!visible)}
            aria-labelledby="customized-dialog-title"
        >
            <Loader loading={flagAddStat} />
            <BootstrapDialogTitle id="customized-dialog-title" onClose={() => setVisible(!visible)}>
                {isEdit ? t('update_supplier') : t('add_supplier')}
            </BootstrapDialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    {' '}
                    <Grid item xl={10} md={10} sm={10} style={{ width: '100%' }}>
                        <TextInput
                            label={t('name_supplier')}
                            valueChange={name}
                            getValue={setName}
                            required
                            autoFocus
                        />
                    </Grid>
                    <Grid item xl={2} md={2} sm={2} style={{ width: '100%' }}>
                        <input
                            type="file"
                            name="upload"
                            accept="image/png,image/jpg,image/jpeg"
                            onChange={handleOnChangeFile}
                            id="upload"
                            style={{ display: 'none' }}
                        />
                        <label htmlFor="upload" className={'upload-img-report col-form-label'}>
                            <span style={{ color: '#058373', fontSize: '14px' }}>Logo </span>
                            <Stack direction="row" spacing={2}>
                                {isEdit && !blob ? (
                                    <img src={imgEdit ? `${glb_sv.urlGetProductImage(imgEdit)}` : imgDefault} alt="" />
                                ) : (
                                    <img src={blob ? blob : imgDefault} alt="" />
                                )}
                            </Stack>
                        </label>
                    </Grid>
                    <Grid item xl={6} md={6} sm={12} style={{ width: '100%' }}>
                        <TextInput label={t('code_supplier')} valueChange={code} required getValue={setcode} />
                    </Grid>
                    <Grid item xl={6} md={6} sm={12} style={{ width: '100%' }}>
                        <TextInput label={t('persitional')} valueChange={nameRepresent} getValue={setNameRepresent} />
                    </Grid>{' '}
                    <Grid item xl={6} md={6} sm={12} style={{ width: '100%' }}>
                        <TextInput label={t('email_supplier')} valueChange={email} getValue={setemail} />
                    </Grid>
                    <Grid item xl={6} md={6} sm={12} style={{ width: '100%' }}>
                        <TextInput label={t('phone_supplier')} valueChange={phone} required getValue={setphone} />
                    </Grid>
                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                        <TextInput label={t('address_supplier')} valueChange={address} getValue={setaddress} />
                    </Grid>{' '}
                    <Grid item sm={12} style={{ width: '100%' }}>
                        <Divider sx={{ borderStyle: 'dashed' }} />
                    </Grid>
                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                        <InputGroupBtn label={t('add_producer')} valueChange={arrSupplier} getValue={setArrSupplier} />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction
                    disabled={flagAddStat}
                    onClick={() => {
                        setVisible(!visible);
                        setFileToUpload(null);
                        setBlob('');
                    }}
                    type={'cancel'}
                    title={t('cancel')}
                />

                <ButtonAction disabled={flagAddStat} onClick={handleAddReport} type={'save'} title={t('save')} />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default SupplierModal;
